import { computed, ref, unref, watch } from 'vue';

const STORAGE_PREFIX = 'real_estate_broker_onboarding';

export const brokerOnboardingStorageKey = ({ accountId, userId }) =>
  `${STORAGE_PREFIX}:${accountId}:${userId}`;

export const useRealEstateBrokerOnboarding = ({
  accountId,
  userId,
  storage = window.localStorage,
}) => {
  const isVisible = ref(false);
  const storageKey = computed(() => {
    const resolvedAccountId = unref(accountId);
    const resolvedUserId = unref(userId);

    if (!resolvedAccountId || !resolvedUserId) return '';

    return brokerOnboardingStorageKey({
      accountId: resolvedAccountId,
      userId: resolvedUserId,
    });
  });

  watch(
    storageKey,
    key => {
      isVisible.value = Boolean(key) && storage.getItem(key) !== 'false';
    },
    { immediate: true }
  );

  const dismiss = () => {
    if (!storageKey.value) return;

    storage.setItem(storageKey.value, 'false');
    isVisible.value = false;
  };

  return { dismiss, isVisible, storageKey };
};
